import AccordionItem from '@atoms/AccordionItem/AccordionItem';
import Checkbox from '@atoms/Checkbox/Checkbox';
import IFilterAccordion from '@models/IFilterAccordion';
import Accordion from '@molecules/Accordion/Accordion';
import { useState } from 'react';

const FilterAccordion = ({
  allowMultipleOpen = true,
  className,
  filters,
  firstOpen = false,
  padding,
  register,
  variant = 'filter',
}: IFilterAccordion) => {
  const [activeIndex, setActiveIndex] = useState(firstOpen ? 0 : -1);

  return (
    <div className={className}>
      <Accordion variant={variant}>
        {filters.map((filterGroup, index) => (
          <AccordionItem
            padding={padding}
            isOpen={allowMultipleOpen ? index === 0 : activeIndex === index}
            variant={variant}
            key={filterGroup.id}
            title={filterGroup.label}
            callback={() => setActiveIndex(activeIndex === index ? -1 : index)}
          >
            <ul className="tw-relative tw-flex tw-max-h-[412px] tw-flex-col tw-items-start tw-justify-start tw-gap-3 tw-overflow-y-auto tw-bg-white tw-p-xs">
              {filterGroup.options.map(({ id, label }) => (
                <Checkbox
                  register={register}
                  key={id}
                  name={String(filterGroup.id)}
                  value={id}
                  label={label}
                />
              ))}
            </ul>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default FilterAccordion;
